var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoNotificationInfo = function SvgIcoNotificationInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M2.167 24c0 12.058 9.775 21.833 21.833 21.833S45.833 36.058 45.833 24 36.058 2.167 24 2.167 2.167 11.942 2.167 24m-1.5 0C.667 36.887 11.113 47.333 24 47.333S47.333 36.887 47.333 24 36.887.667 24 .667.667 11.113.667 24",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M22.824 15.045q.574-.573 1.375-.573.803 0 1.371.572.569.573.569 1.378 0 .807-.569 1.372-.57.567-1.37.567-.803 0-1.376-.567a1.86 1.86 0 0 1-.574-1.372q0-.805.574-1.378m1.37 5.26c-1.073 0-1.944.871-1.944 1.945v9.722a1.944 1.944 0 0 0 3.889 0V22.25c0-1.074-.87-1.944-1.945-1.944",
    clipRule: "evenodd"
  })));
};
export default SvgIcoNotificationInfo;